import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './SharedBottomModuleContent.scss';

const SharedBottomModuleContentComponent = ({ bottomModule }) => {
    return (
        <>
            {bottomModule.map(item =>
                item.title && item.description ? (
                    <React.Fragment key={item.title}>
                        <h4 className={styles.title}>{item.title}</h4>
                        <div
                            className={styles.description}
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    </React.Fragment>
                ) : null
            )}
        </>
    );
};

SharedBottomModuleContentComponent.propTypes = {
    bottomModule: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
        })
    ),
};

export const SharedBottomModuleContent = createFragmentContainer(
    SharedBottomModuleContentComponent,
    {
        bottomModule: graphql`
            fragment SharedBottomModuleContent_bottomModule on BottomModule @relay(plural: true) {
                title
                description
            }
        `,
    }
);
